import React, { useEffect, useContext, useMemo, useState } from 'react';
import { reaction } from 'mobx';
import { StoreContext } from '@src/framework/frame/components/provider';
import { DEFAULT_CLICK_SPID } from '@tencent/slide-sdk-model';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';

interface IStyle {
    width?: number;
    height?: number;
    top?: number;
    left?: number;
    padding?: number;
    transform?: string;
    position?: string;
    border?: string;
    boxSizing?: string;
}

function getAppServices(): IEditorAppServices {
    return AppServiceProvider.getInstance().getAppServices() as
        IEditorAppServices;
}

const HighlightBorder = (): React.ReactElement | null => {
    const context = useContext(StoreContext);
    const [modelId, setModelId] = useState(null);

    useEffect(() => {
        const highlightReaction = reaction(
            () => getAppServices().viewableServiceLayer.selectionService.currentSlide?.highlightModelId,
            (modelId) => {
                // @ts-ignore
                setModelId(modelId);
            },
        );
        return () => {
            // 组件卸载时，移除监听
            highlightReaction?.();
        };
    }, []);

    /**
     * 获取slide上的所有元素，包括组合及组合子元素
     */
    const getSlideChildren = (slide): any[] => {
        const list: any[] = [];
        slide?.children?.forEach((model) => {
            list.indexOf(model) === -1 && list.push(model);
            if (model.children?.length > 0) {
                list.push(...getSlideChildren(model));
            }
        });
        return list;
    };

    const getStyleObj = (modelId): IStyle => {
        const { currentSlide } = getAppServices().viewableServiceLayer.selectionService;
        const slideChildren = getSlideChildren(currentSlide);
        const highlightModel = slideChildren.find(elementModel => elementModel.id === modelId);
        if (!highlightModel) return {};

        const padding = 10;
        const style: IStyle = {
            position: 'absolute',
            border: '2px solid var(--accent-default)',
            padding,
            boxSizing: 'content-box',
        };
        const frame = highlightModel.getFrame?.().frameOnSlide();

        style.width = Math.floor(frame.width);
        style.height = Math.floor(frame.height);
        style.left = Math.floor(frame.left) - padding - 2;
        style.top = Math.floor(frame.top) - padding - 2;
        style.transform = `rotate(${frame.rotate}deg)`;

        return style;
    };

    return useMemo(() => {
        if (!modelId || modelId === DEFAULT_CLICK_SPID) return null;
        return (
            <div style={getStyleObj(modelId) as React.CSSProperties}>
            </div>
        );
    }, [modelId]);
};

export default HighlightBorder;
